// // src/components/user/AIChatbot.jsx
// import React, { useState, useRef, useEffect } from 'react';
// import { useAI } from '../../context/AIContext';
// import { 
//   FaRobot, 
//   FaPaperPlane, 
//   FaTimes, 
//   FaUser, 
//   FaSpinner,
//   FaTrash
// } from 'react-icons/fa';

// const AIChatbot = () => {
//   const { askQuestion, clearChat, isLoading, aiStatus } = useAI();
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState('');
//   const [showWelcome, setShowWelcome] = useState(true);
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);

//   const suggestedQuestions = [
//     "What services does Brasotech offer?",
//     "Is Brasotech registered in Zambia?",
//     "How can I contact Brasotech?",
//     "What types of projects do you work on?"
//   ];

//   // Initial greeting
//   useEffect(() => {
//     if (isOpen && messages.length === 0) {
//       const welcomeMessage = {
//         id: Date.now(),
//         text: "Hello! I'm BrasoBot, your AI assistant for Brasotech Investments Limited. I can help you with information about our services, certifications, projects, and more. How can I assist you today?",
//         sender: 'bot',
//         timestamp: new Date()
//       };
//       setMessages([welcomeMessage]);
//     }
//   }, [isOpen]);

//   // Auto-scroll to bottom
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages]);

//   // Focus input when opened
//   useEffect(() => {
//     if (isOpen && inputRef.current) {
//       setTimeout(() => {
//         inputRef.current.focus();
//       }, 100);
//     }
//   }, [isOpen]);

//   const handleSend = async () => {
//     if (!input.trim() || isLoading) return;

//     const userMessage = input.trim();
//     setInput('');
    
//     // Add user message
//     const userMsg = {
//       id: Date.now(),
//       text: userMessage,
//       sender: 'user',
//       timestamp: new Date()
//     };
    
//     setMessages(prev => [...prev, userMsg]);
//     setShowWelcome(false);

//     try {
//       // Get AI response
//       const response = await askQuestion(userMessage);
      
//       // Add AI response
//       const botMsg = {
//         id: Date.now() + 1,
//         text: response.answer,
//         sender: 'bot',
//         timestamp: new Date(response.timestamp)
//       };
      
//       setMessages(prev => [...prev, botMsg]);
//     } catch (error) {
//       console.error('Error in chat:', error);
//       const errorMsg = {
//         id: Date.now() + 1,
//         text: "I apologize, but I'm having trouble responding right now. Please try again or contact us directly through our website.",
//         sender: 'bot',
//         timestamp: new Date()
//       };
//       setMessages(prev => [...prev, errorMsg]);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSend();
//     }
//   };

//   const handleClearChat = async () => {
//     await clearChat();
//     setMessages([]);
//     setShowWelcome(true);
//   };

//   const handleSuggestedQuestion = async (question) => {
//     setInput(question);
//     setTimeout(() => {
//       handleSend();
//     }, 100);
//   };

//   const getStatusColor = () => {
//     switch(aiStatus) {
//       case 'healthy': return 'bg-green-500';
//       case 'degraded': return 'bg-yellow-500';
//       default: return 'bg-gray-500';
//     }
//   };

//   const getStatusText = () => {
//     switch(aiStatus) {
//       case 'healthy': return 'AI Online';
//       case 'degraded': return 'AI Limited';
//       default: return 'AI Offline';
//     }
//   };

//   return (
//     <>
//       {/* Chat Toggle Button */}
//       <button
//         onClick={() => setIsOpen(true)}
//         className="fixed bottom-6 right-6 z-50 flex flex-col items-center group"
//       >
//         <div className={`w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform group-hover:scale-110 ${getStatusColor()}`}>
//           <FaRobot className="h-8 w-8 text-white" />
//         </div>
//         <div className="mt-2 bg-white px-3 py-1 rounded-full shadow text-xs font-semibold">
//           Ask BrasoBot
//         </div>
//         <div className={`mt-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor()} text-white`}>
//           {getStatusText()}
//         </div>
//       </button>

//       {/* Chat Modal */}
//       {isOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-end p-4 sm:p-6 pointer-events-none">
//           <div className="relative w-full max-w-md h-[600px] bg-white rounded-2xl shadow-2xl flex flex-col pointer-events-auto overflow-hidden">
//             {/* Header */}
//             <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4">
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center space-x-3">
//                   <div className="relative">
//                     <FaRobot className="h-8 w-8" />
//                     <div className={`absolute -top-1 -right-1 w-3 h-3 rounded-full ${getStatusColor()}`}></div>
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-bold">BrasoBot AI Assistant</h3>
//                     <p className="text-sm text-blue-100">Ask me about Brasotech</p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="text-white hover:text-gray-200 transition-colors"
//                 >
//                   <FaTimes className="h-6 w-6" />
//                 </button>
//               </div>
//             </div>

//             {/* Messages Container */}
//             <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
//               {showWelcome && (
//                 <div className="mb-6">
//                   <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
//                     <h4 className="font-bold text-gray-800 mb-2">Suggested Questions</h4>
//                     <div className="space-y-2">
//                       {suggestedQuestions.map((question, index) => (
//                         <button
//                           key={index}
//                           onClick={() => handleSuggestedQuestion(question)}
//                           className="block w-full text-left p-3 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors text-sm text-gray-700"
//                         >
//                           {question}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Messages */}
//               <div className="space-y-4">
//                 {messages.map((message) => (
//                   <div
//                     key={message.id}
//                     className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`}
//                   >
//                     <div
//                       className={`max-w-[80%] rounded-2xl p-4 ${
//                         message.sender === 'user'
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-br-none'
//                           : 'bg-white border border-gray-200 rounded-bl-none shadow-sm'
//                       }`}
//                     >
//                       <div className="flex items-start space-x-2">
//                         {message.sender === 'bot' && (
//                           <FaRobot className="h-5 w-5 text-blue-600 flex-shrink-0 mt-1" />
//                         )}
//                         {message.sender === 'user' && (
//                           <FaUser className="h-5 w-5 text-white flex-shrink-0 mt-1" />
//                         )}
//                         <div className="flex-1">
//                           <p className="text-sm whitespace-pre-wrap">{message.text}</p>
//                           <p className={`text-xs mt-2 ${message.sender === 'user' ? 'text-blue-200' : 'text-gray-500'}`}>
//                             {new Date(message.timestamp).toLocaleTimeString([], { 
//                               hour: '2-digit', 
//                               minute: '2-digit' 
//                             })}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//                 {isLoading && (
//                   <div className="flex justify-start">
//                     <div className="max-w-[80%] rounded-2xl p-4 bg-white border border-gray-200 rounded-bl-none shadow-sm">
//                       <div className="flex items-center space-x-3">
//                         <FaRobot className="h-5 w-5 text-blue-600" />
//                         <div className="flex space-x-1">
//                           <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
//                           <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
//                           <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
//                         </div>
//                         <span className="text-sm text-gray-500">Thinking...</span>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//                 <div ref={messagesEndRef} />
//               </div>
//             </div>

//             {/* Input Area */}
//             <div className="border-t border-gray-200 p-4 bg-white">
//               <div className="flex space-x-2">
//                 <div className="flex-1 relative">
//                   <input
//                     ref={inputRef}
//                     type="text"
//                     value={input}
//                     onChange={(e) => setInput(e.target.value)}
//                     onKeyPress={handleKeyPress}
//                     placeholder="Ask about Brasotech..."
//                     className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all"
//                     disabled={isLoading}
//                   />
//                   <button
//                     onClick={handleClearChat}
//                     className="absolute right-12 top-3 text-gray-400 hover:text-gray-600 transition-colors"
//                     title="Clear chat"
//                   >
//                     <FaTrash className="h-5 w-5" />
//                   </button>
//                 </div>
//                 <button
//                   onClick={handleSend}
//                   disabled={isLoading || !input.trim()}
//                   className={`px-4 py-3 rounded-xl flex items-center justify-center ${
//                     isLoading || !input.trim()
//                       ? 'bg-gray-300 cursor-not-allowed'
//                       : 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800'
//                   } text-white transition-all duration-200`}
//                 >
//                   {isLoading ? (
//                     <FaSpinner className="h-5 w-5 animate-spin" />
//                   ) : (
//                     <FaPaperPlane className="h-5 w-5" />
//                   )}
//                 </button>
//               </div>
              
//               <div className="mt-3 text-center">
//                 <p className="text-xs text-gray-500">
//                   BrasoBot can answer questions about services, certifications, and more
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default AIChatbot;






import React, { useState, useRef, useEffect } from 'react';
import { useAI } from '../../context/AIContext';
import { 
  FaRobot, 
  FaPaperPlane, 
  FaTimes, 
  FaUser, 
  FaSpinner,
  FaTrash,
  FaExternalLinkAlt
} from 'react-icons/fa';

const AIChatbot = () => {
  const { askQuestion, clearChat, isLoading, aiStatus } = useAI();
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [showWelcome, setShowWelcome] = useState(true);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const suggestedQuestions = [
    "What services does Brasotech offer?",
    "Is Brasotech registered in Zambia?",
    "How can I contact Brasotech?",
    "What types of projects do you work on?"
  ];

  // Function to convert URLs in text to clickable links
  const formatMessage = (text) => {
    if (!text) return text;
    
    // Regular expression to find URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    // Split text by URLs and map parts
    const parts = text.split(urlRegex);
    
    return parts.map((part, index) => {
      // Check if this part is a URL
      if (part.match(urlRegex)) {
        return (
          <span key={index} className="inline-flex items-center">
            <a 
              href={part} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline mr-1"
            >
              {part}
            </a>
            <FaExternalLinkAlt className="h-3 w-3 text-blue-500" />
          </span>
        );
      }
      return part;
    });
  };

  // Function to clean up weird formatting from AI responses
  const cleanResponseText = (text) => {
    if (!text) return text;
    
    // Remove markdown formatting that might appear as raw text
    let cleaned = text
      // Remove **bold** markers but keep text
      .replace(/\*\*(.*?)\*\*/g, '$1')
      // Remove *bullet points* that appear as raw asterisks
      .replace(/^\s*\*\s+/gm, '• ')
      // Remove numbered list markers that appear as raw text
      .replace(/^\s*\d+\.\s+/gm, '')
      // Remove section headers with ##
      .replace(/^#+\s+/gm, '')
      // Remove any raw markdown link syntax [text](url)
      .replace(/\[(.*?)\]\(.*?\)/g, '$1')
      // Remove repeated instruction text that shouldn't be in responses
      .replace(/##\s+.*?\n\n/gs, '')
      .replace(/You are BrasoBot.*?\n\n/gs, '')
      .replace(/RESPONSE GUIDELINES.*?\n\n/gs, '')
      .replace(/SPECIFIC RESPONSE EXAMPLES.*?\n\n/gs, '');
    
    // Trim excessive whitespace
    cleaned = cleaned.trim().replace(/\n\s*\n\s*\n/g, '\n\n');
    
    return cleaned;
  };

  // Initial greeting
  useEffect(() => {
    if (isOpen && messages.length === 0) {
      const welcomeMessage = {
        id: Date.now(),
        text: "Hello! I'm BrasoBot, your AI assistant for Brasotech Investments Limited. I can help you with information about our services, certifications, projects, and more. How can I assist you today?",
        sender: 'bot',
        timestamp: new Date()
      };
      setMessages([welcomeMessage]);
    }
  }, [isOpen]);

  // Auto-scroll to bottom
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Focus input when opened
  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [isOpen]);

  const handleSend = async () => {
    if (!input.trim() || isLoading) return;

    const userMessage = input.trim();
    setInput('');
    
    // Add user message
    const userMsg = {
      id: Date.now(),
      text: userMessage,
      sender: 'user',
      timestamp: new Date()
    };
    
    setMessages(prev => [...prev, userMsg]);
    setShowWelcome(false);

    try {
      // Get AI response
      const response = await askQuestion(userMessage);
      
      // Clean the AI response before displaying
      const cleanedAnswer = cleanResponseText(response.answer);
      
      // Add AI response
      const botMsg = {
        id: Date.now() + 1,
        text: cleanedAnswer,
        sender: 'bot',
        timestamp: new Date(response.timestamp)
      };
      
      setMessages(prev => [...prev, botMsg]);
    } catch (error) {
      console.error('Error in chat:', error);
      const errorMsg = {
        id: Date.now() + 1,
        text: "I apologize, but I'm having trouble responding right now. Please try again or contact us directly through our website.",
        sender: 'bot',
        timestamp: new Date()
      };
      setMessages(prev => [...prev, errorMsg]);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleClearChat = async () => {
    await clearChat();
    setMessages([]);
    setShowWelcome(true);
  };

  const handleSuggestedQuestion = async (question) => {
    setInput(question);
    setTimeout(() => {
      handleSend();
    }, 100);
  };

  const getStatusColor = () => {
    switch(aiStatus) {
      case 'healthy': return 'bg-green-500';
      case 'degraded': return 'bg-yellow-500';
      default: return 'bg-gray-500';
    }
  };

  const getStatusText = () => {
    switch(aiStatus) {
      case 'healthy': return 'AI Online';
      case 'degraded': return 'AI Limited';
      default: return 'AI Offline';
    }
  };

  return (
    <>
      {/* Chat Toggle Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-50 flex flex-col items-center group"
      >
        <div className={`w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform group-hover:scale-110 ${getStatusColor()}`}>
          <FaRobot className="h-8 w-8 text-white" />
        </div>
        <div className="mt-2 bg-white px-3 py-1 rounded-full shadow text-xs font-semibold">
          Ask BrasoBot
        </div>
        <div className={`mt-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor()} text-white`}>
          {getStatusText()}
        </div>
      </button>

      {/* Chat Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-end justify-end p-4 sm:p-6 pointer-events-none">
          <div className="relative w-full max-w-md h-[600px] bg-white rounded-2xl shadow-2xl flex flex-col pointer-events-auto overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    <FaRobot className="h-8 w-8" />
                    <div className={`absolute -top-1 -right-1 w-3 h-3 rounded-full ${getStatusColor()}`}></div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold">BrasoBot AI Assistant</h3>
                    <p className="text-sm text-blue-100">Ask me about Brasotech</p>
                  </div>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-white hover:text-gray-200 transition-colors"
                >
                  <FaTimes className="h-6 w-6" />
                </button>
              </div>
            </div>

            {/* Messages Container */}
            <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
              {showWelcome && (
                <div className="mb-6">
                  <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
                    <h4 className="font-bold text-gray-800 mb-2">Suggested Questions</h4>
                    <div className="space-y-2">
                      {suggestedQuestions.map((question, index) => (
                        <button
                          key={index}
                          onClick={() => handleSuggestedQuestion(question)}
                          className="block w-full text-left p-3 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors text-sm text-gray-700"
                        >
                          {question}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Messages */}
              <div className="space-y-4">
                {messages.map((message) => (
                  <div
                    key={message.id}
                    className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`}
                  >
                    <div
                      className={`max-w-[80%] rounded-2xl p-4 ${
                        message.sender === 'user'
                          ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-br-none'
                          : 'bg-white border border-gray-200 rounded-bl-none shadow-sm'
                      }`}
                    >
                      <div className="flex items-start space-x-2">
                        {message.sender === 'bot' && (
                          <FaRobot className="h-5 w-5 text-blue-600 flex-shrink-0 mt-1" />
                        )}
                        {message.sender === 'user' && (
                          <FaUser className="h-5 w-5 text-white flex-shrink-0 mt-1" />
                        )}
                        <div className="flex-1">
                          <p className="text-sm whitespace-pre-wrap">
                            {formatMessage(message.text)}
                          </p>
                          <p className={`text-xs mt-2 ${message.sender === 'user' ? 'text-blue-200' : 'text-gray-500'}`}>
                            {new Date(message.timestamp).toLocaleTimeString([], { 
                              hour: '2-digit', 
                              minute: '2-digit' 
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {isLoading && (
                  <div className="flex justify-start">
                    <div className="max-w-[80%] rounded-2xl p-4 bg-white border border-gray-200 rounded-bl-none shadow-sm">
                      <div className="flex items-center space-x-3">
                        <FaRobot className="h-5 w-5 text-blue-600" />
                        <div className="flex space-x-1">
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                        </div>
                        <span className="text-sm text-gray-500">Thinking...</span>
                      </div>
                    </div>
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>
            </div>

            {/* Input Area */}
            <div className="border-t border-gray-200 p-4 bg-white">
              <div className="flex space-x-2">
                <div className="flex-1 relative">
                  <input
                    ref={inputRef}
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Ask about Brasotech..."
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all"
                    disabled={isLoading}
                  />
                  <button
                    onClick={handleClearChat}
                    className="absolute right-12 top-3 text-gray-400 hover:text-gray-600 transition-colors"
                    title="Clear chat"
                  >
                    <FaTrash className="h-5 w-5" />
                  </button>
                </div>
                <button
                  onClick={handleSend}
                  disabled={isLoading || !input.trim()}
                  className={`px-4 py-3 rounded-xl flex items-center justify-center ${
                    isLoading || !input.trim()
                      ? 'bg-gray-300 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800'
                  } text-white transition-all duration-200`}
                >
                  {isLoading ? (
                    <FaSpinner className="h-5 w-5 animate-spin" />
                  ) : (
                    <FaPaperPlane className="h-5 w-5" />
                  )}
                </button>
              </div>
              
              <div className="mt-3 text-center">
                <p className="text-xs text-gray-500">
                  BrasoBot can answer questions about services, certifications, and more
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AIChatbot;